export const PAYMENT_TERMS = [
    { value: '', label: 'Choose payment terms' },
    { value: 'net_15', label: 'Net 15' },
    { value: 'net_30', label: 'Net 30' },
    { value: 'net_45', label: 'Net 45' },
    { value: 'due_on_receipt', label: 'Due on Receipt' },
    { value: 'milestone_based', label: 'Milestone Based' },
    { value: 'custom', label: 'Custom' }
];

export const PAYMENT_TERMS_LABELS = Object.fromEntries(
    PAYMENT_TERMS.filter(t => t.value).map(t => [t.value, t.label])
);
